import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.432 3.699 C 10.253 3.781,10.102 3.929,9.997 4.125 C 9.919 4.271,9.918 4.286,9.908 7.085 L 9.897 9.897 7.085 9.908 C 4.286 9.918,4.271 9.919,4.125 9.997 C 3.795 10.173,3.632 10.439,3.631 10.800 C 3.629 11.221,3.896 11.566,4.295 11.658 C 4.394 11.681,5.485 11.695,7.178 11.696 L 9.900 11.697 9.900 14.387 C 9.900 15.995,9.914 17.153,9.936 17.267 C 10.016 17.690,10.360 17.971,10.797 17.971 C 11.073 17.971,11.246 17.902,11.431 17.716 C 11.691 17.456,11.677 17.633,11.689 14.512 L 11.699 11.699 14.512 11.689 C 17.633 11.677,17.456 11.691,17.716 11.431 C 17.902 11.246,17.971 11.073,17.971 10.797 C 17.971 10.360,17.690 10.016,17.267 9.936 C 17.153 9.914,15.995 9.900,14.387 9.900 L 11.697 9.900 11.696 7.178 C 11.695 5.485,11.681 4.394,11.658 4.295 C 11.566 3.896,11.221 3.629,10.800 3.631 C 10.664 3.631,10.522 3.658,10.432 3.699 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgAdd;
